import brand1 from "../../../assets/brands/1.webp";
import brand2 from "../../../assets/brands/2.webp";
import brand3 from "../../../assets/brands/3.webp";
import brand4 from "../../../assets/brands/4.webp";
import brand5 from "../../../assets/brands/5.webp";
import brand6 from "../../../assets/brands/6.png";
import brand7 from "../../../assets/brands/7.webp";
import brand8 from "../../../assets/brands/8.webp";
import brand9 from "../../../assets/brands/9.webp";
import brand10 from "../../../assets/brands/10.png";
import brand11 from "../../../assets/brands/11.webp";
import brand12 from "../../../assets/brands/12.webp";
import brand13 from "../../../assets/brands/13.webp";
import brand14 from "../../../assets/brands/14.webp";
import brand15 from "../../../assets/brands/15.webp";
import brand16 from "../../../assets/brands/16.webp";
import brand17 from "../../../assets/brands/17.webp";
import brand18 from "../../../assets/brands/18.webp";

const images = [
  brand1,
  brand2,
  brand3,
  brand4,
  brand5,
  brand6,
  brand7,
  brand8,
  brand9,
  brand10,
  brand11,
  brand12,
  brand13,
  brand14,
  brand15,
  brand16,
  brand17,
  brand18,
];

export default images
